import { withProps } from 'recompose'
import chunk from 'lodash/chunk'
import { getCanonicalUrl, injectDynamicVerbiage } from './helpers'
import {
  BRANDS_SUBHEADING_MAP,
  SUBHEADING_MAP,
  SELECTOR_SUBHEADING_MAP,
  YMME_PAGE_IMAGE_WIDTH,
  YMME_PAGE_IMAGE_HEIGHT,
  META_DESCRIPTION_MAP,
  META_TITLE_MAP,
  SCHEMAS_NAME_MAP
} from './constants'
import { generateUrl } from 'components/common/VehicleImage/helpers'
import { DEFAULT_COLOR, DEFAULT_H_ALIGNMENT, DEFAULT_VIEW, DEFAULT_V_ALIGNMENT } from 'components/common/VehicleImage/constants'

export const mapStateToProps = ({ app: { data }}) => ({
  canonicalUrl: data ? getCanonicalUrl(data) : ''
})

export const withGroupedList = withProps(({ list }) => {
  const columns = 6

  return {
    columnWidth: Array(columns).join(`${(100 / columns).toFixed(2)}% `).trim(),
    groupedList: chunk(list, Math.ceil(list.length / columns))
  }
})

export const withDynamicVerbiage = withProps(({
  title,
  '@type': pageType,
  description,
  ...props
}) => ({
  title: injectDynamicVerbiage({ string: title, ...props }),
  description: injectDynamicVerbiage({ string: description, ...props }),
  subheading: injectDynamicVerbiage({ string: SUBHEADING_MAP[pageType], ...props }),
  brandsSubheading: injectDynamicVerbiage({ string: BRANDS_SUBHEADING_MAP[pageType], ...props }),
  selectorSubheading: injectDynamicVerbiage({ string: SELECTOR_SUBHEADING_MAP[pageType], ...props }),
  metaDescription: injectDynamicVerbiage({ string: META_DESCRIPTION_MAP[pageType], ...props }),
  metaTitle: injectDynamicVerbiage({ string: META_TITLE_MAP[pageType], ...props }),
  schemasName: injectDynamicVerbiage({ string: SCHEMAS_NAME_MAP[pageType], ...props })
}))

export const withImageSrc = withProps(({
  vehicleMaker,
  vehicleModel,
  vehicleYear
}) => ({
  imageSrc: generateUrl({
    year: vehicleYear,
    make: vehicleMaker,
    model: vehicleModel,
    submodel: '',
    color: DEFAULT_COLOR,
    view: DEFAULT_VIEW,
    vAlign: DEFAULT_V_ALIGNMENT,
    hAlign: DEFAULT_H_ALIGNMENT,
    height: YMME_PAGE_IMAGE_HEIGHT,
    width: YMME_PAGE_IMAGE_WIDTH,
    exactMatch: false
  })
}))
